// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import {
  ConfigProvider,
  App,
} from 'antd';
import { ApplyPluginsType } from 'umi';
import { getPluginManager } from '../core/plugin';
import { AntdConfigContext, AntdConfigContextSetter } from './context';
import merge from '/Users/afeng/Desktop/所有项目代码/dingyan/dy-maritime-ui/node_modules/lodash/merge'

let cacheAntdConfig = null;

const getAntdConfig = () => {
  if(!cacheAntdConfig){
    cacheAntdConfig = getPluginManager().applyPlugins({
      key: 'antd',
      type: ApplyPluginsType.modify,
      initialValue: {
        ...{"theme":{"cssVar":{"key":"linson-ds"},"token":{"fontFamily":"AlibabaSans, sans-serif","colorPrimary":"#1B6FE8","colorSuccess":"#10B981","colorWarning":"#F59E0B","colorError":"#EF4444","colorInfo":"#1B6FE8","borderRadius":4,"controlHeight":34,"lineHeight":1.5,"fontSize":13,"motionDurationSlow":"0.15s","motionDurationMid":"0.12s","motionDurationFast":"0.08s"},"components":{"Table":{"cellPaddingBlock":10,"cellPaddingInline":12,"headerBg":"#fafafa","headerColor":"#64748B","rowHoverBg":"#E6F4FA","borderColor":"#f0f0f0"},"Form":{"itemMarginBottom":16,"verticalLabelPadding":"0 0 4px"},"Card":{"paddingLG":16,"borderRadiusLG":6},"Modal":{"contentPadding":0,"headerPadding":0,"bodyPadding":0,"footerPadding":0,"headerMarginBottom":0,"footerMarginTop":0,"confirmBodyPadding":0},"Tag":{"defaultBg":"#F1F5F9","defaultColor":"#475569"}}}},
        appConfig: {},
      },
    });
    if (!cacheAntdConfig.theme) {
      cacheAntdConfig.theme = {};
    }
  }
  return cacheAntdConfig;
}

function AntdProvider({ children }) {
  let container = children;

  const [antdConfig, _setAntdConfig] = React.useState(() => {
    const {
      appConfig: _,
      ...finalConfigProvider
    } = getAntdConfig();
    return finalConfigProvider
  });
  const setAntdConfig: typeof _setAntdConfig = (newConfig) => {
    _setAntdConfig(prev => {
      return merge({}, prev, typeof newConfig === 'function' ? newConfig(prev) : newConfig)
    })
  }


  if (antdConfig.prefixCls) {
    ConfigProvider.config({
      prefixCls: antdConfig.prefixCls,
    });
  };

  if (antdConfig.iconPrefixCls) {
    // Icons in message need to set iconPrefixCls via ConfigProvider.config()
    ConfigProvider.config({
      iconPrefixCls: antdConfig.iconPrefixCls,
    });
  };

  if (antdConfig.theme) {
    // Pass config theme to static method
    ConfigProvider.config({
      theme: antdConfig.theme,
    });
  }

  container = <ConfigProvider {...antdConfig}>{container}</ConfigProvider>;


  container = (
    <AntdConfigContextSetter.Provider value={setAntdConfig}>
      <AntdConfigContext.Provider value={antdConfig}>
        {container}
      </AntdConfigContext.Provider>
    </AntdConfigContextSetter.Provider>
  )

  return container;
}

export function rootContainer(children) {
  return (
    <AntdProvider>
      {children}
    </AntdProvider>
  );
}

// The App component should be under ConfigProvider
// plugin-locale has other ConfigProvider
export function innerProvider(container: any) {
  const {
    appConfig: finalAppConfig = {},
  } = getAntdConfig();
  return <App {...finalAppConfig}>{container}</App>;
}
